import { render, staticRenderFns } from "./sr2.vue?vue&type=template&id=4d191f9f&scoped=true&"
import script from "./sr2.vue?vue&type=script&lang=js&"
export * from "./sr2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d191f9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdGG/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d191f9f')) {
      api.createRecord('4d191f9f', component.options)
    } else {
      api.reload('4d191f9f', component.options)
    }
    module.hot.accept("./sr2.vue?vue&type=template&id=4d191f9f&scoped=true&", function () {
      api.rerender('4d191f9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/config/systemReport/sr2.vue"
export default component.exports